import React, { useEffect, useState } from 'react'

export default function InputHandler({ form_data, setFormData, Name = "input", RadioName = "", RadioValue = "", Type = "text", Label = "", is_disabled = false }) {
  return (
    <div className='form-group'>
      <label className="form-label">{Label}</label>

      {is_disabled ?
        <div class="input-group">
          <div class="input-group-text">
            <input class="form-check-input mt-0" disabled={true} checked={RadioValue == form_data[RadioName]} type="radio" name={RadioName} value={RadioValue} aria-label="" />
          </div>
          <input
            type={Type}
            placeholder={`Enter ${Label}`}
            className="form-control"
            value={form_data[Name]}
            disabled={true}
          />
        </div>
        :
        <div class="input-group">
          <div class="input-group-text">
            <input class="form-check-input mt-0" checked={RadioValue == form_data[RadioName]} type="radio" onClick={() => {setFormData({...form_data, [RadioName]: RadioValue})}} name={RadioName} value={RadioValue} aria-label="" />
          </div>
          <input
            type={Type}
            placeholder={`Enter ${Label}`}
            className="form-control"
            value={form_data[Name]}
            onChange={(e) => setFormData({ ...form_data, [Name]: e.target.value })}
          />
        </div>
      }
    </div>
  )
}
